<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="3"></tabbar>
    <!-- <img width="100%" src="../../images/head.png" /> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
   
       <div class="person">
        <div class="kefu"
          @click="clicked_OnlineService()"
          style="cursor: pointer;">
        <img
          style="margin-top: 30px; text-align: center"
          src="../../images/kefu.png"
        />
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          在线客服
        </div>
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          售后处理
        </div>
      </div>
    </div>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="top">
        <span class="text">公告通知</span>
        <div class="sj"></div>
      </div>
      <div class="bottom borderShadow flexStyle3">
        <div class="right">
          {{ web_convert_instructions }}
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer @watchQA="footerWatchQA"></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import { helperCenter1nd2Request } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      articleId: "", // 1.2.文章详情id
      rightInfo: [], // 1.3.右侧问答数据
      sysId: "", // 1.4.sysId
      web_convert_instructions: "", //
    };
  },

  components: {
    tabbar,
    cFooter: footer,
  },

  methods: {
    // 3.methods
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },
    getCurrentPageInfo() {
      // 3.1.getCurrentPageInfo
      let data = {
        sysId: this.sysId,
      };

      helperCenter1nd2Request(data).then((res) => {
        if (res) {
          this.currentPageInfo = res.data;
          if (!this.articleId) {
            this.articleId = res.data[0].list[0].article_id;
          }
          if (this.articleId) {
            this.getMessageDetail();
          }
        }
      });
    },

    watchQA(articleId) {
      // 3.3.查看问题
      if (this.articleId != articleId) {
        this.articleId = articleId;
        this.getMessageDetail();
      }
    },
  },

  mounted() {
    this.sysId = localStorage.sysId || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";
    this.web_convert_instructions = localStorage.web_convert_instructions || "";

    if (this.$route.query.obj) {
      this.articleId = JSON.parse(
        decodeURIComponent(this.$route.query.obj)
      ).articleId;
    }

    this.getCurrentPageInfo();
  },
};
</script>

<style scoped lang="scss">
@import "./giftsExchange.scss";
</style>